import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { map, scan } from 'rxjs/operators';
import { GetUserOutcomeStatsDto } from '../models';
import { WorkService } from '../services';

@Component({
  selector: 'app-stats-modal',
  templateUrl: './stats-modal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsModalComponent {
  initial = new BehaviorSubject<boolean>(true);
  viewModel$: Observable<ViewModel>;

  constructor(
    public activeModal: NgbActiveModal,
    private workSvc: WorkService
  ) {
    this.viewModel$ = this.initViewModel();
    this.workSvc.loadStats();
  }

  private initViewModel() {
    return merge<Partial<ViewModel>>(
      this.workSvc.userOutcomeStats$.pipe(map((results) => ({ results }))),
      this.initial.pipe(map((initial) => ({ initial })))
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }
}

interface ViewModel {
  initial: boolean;
  results: GetUserOutcomeStatsDto[] | undefined;
}
